import { BindAll } from 'lodash-decorators'

import { MyAccountOrderController } from './account-order'
import { MyAccountBishanController } from './account-bishan'
import { MyAccountCoinController } from './account-coin'
import { MyAccountExchangeController } from './account-exchange'

@BindAll()
export class MyAccountController {
  /**
   * 我的订单
   */
  Order = new MyAccountOrderController()
  /**
   * 我的笔山
   */
  BiShan = new MyAccountBishanController()
  /**
   * 我的铜板儿
   */
  Coin = new MyAccountCoinController()
  /**
   * 我的积分兑换
   */
  Exchange = new MyAccountExchangeController()

  onReset() {
    this.Order.onReset()
    this.BiShan.reset()
  }
}
